<template>
    <div class="my-mbinfo">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
        </van-nav-bar>
        <div>
            <van-cell-group custom-class="goods-cell-group">
                <van-cell is-link style="height: 63px;">
                    <div class="mbinfo-titel">
                        <div style="width: 80%;">
                            <van-uploader :after-read="onRead" accept="image/jpeg">
                                头像
                            </van-uploader>
                        </div>
                        <div style="height: 40px;width: 40px;text-align: right" @click="totwo(headPortrait)">
                            <img :src="headPortrait" v-if="headPortrait" style="width: 40px;height: 40px;">
                            <img src="./../../assets/touxiang.png" v-if="!headPortrait"
                                 style="width: 40px;height: 40px;">
                        </div>
                    </div>
                </van-cell>
            </van-cell-group>
            <van-cell-group custom-class="goods-cell-group">
                <van-cell @click="toUpdateMember('nc',memberName)" is-link>
                    <div class="mbinfo-titel">
                        <span style="font-size: 12px">昵称</span>
                        <span style="font-size: 12px">{{memberName}}</span>
                    </div>
                </van-cell>
            </van-cell-group>
            <van-cell-group custom-class="goods-cell-group">
                <van-cell @click="toUpdateMember('sr',srDate)" is-link>
                    <div class="mbinfo-titel">
                        <span style="font-size: 12px">生日</span>
                        <span style="font-size: 12px">{{srDate}}</span>
                    </div>
                </van-cell>
            </van-cell-group>
            <van-cell-group custom-class="goods-cell-group">
                <van-cell @click="toUpdateMember('sjh',phone)" is-link>
                    <div class="mbinfo-titel">
                        <span style="font-size: 12px">手机号</span>
                        <span style="font-size: 12px">{{phone}}</span>
                    </div>
                </van-cell>
            </van-cell-group>
        </div>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName} from "../../utils/auth";
    import {ImagePreview} from 'vant';

    export default {
        data() {
            return {
                title: '个人资料',
                deptId: '',
                token: '',
                member: {},
                memberId: '',
                headPortrait: '',
                memberName: '',
                srDate: '',
                phone: '',
            };
        },
        async created() {
            document.title = getDeptName()
            this.deptId = getDeptId()
            this.token = getCookie("spmToken")
            this.getMemberInfo()
        },
        methods: {
            async onRead(file) {
                let formData = new FormData();
                formData.append('file', file.file);
                let res = await this.$fileUpload("/spm/uploadHeadImg/" + this.memberId, formData)
                if (res.code == 200) {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: '#1989fa'
                    });
                    this.getMemberInfo()
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },

            totwo(headPortrait) {
                var url = './../../assets/touxiang.png'
                if (headPortrait) {
                    url = headPortrait
                }
                var arr = []
                arr.push(url)
                ImagePreview({
                    images: arr,
                    startPosition: 0,
                    loop: false, //是否开启循环
                    closeable: true,
                    closeIconPosition: 'top-left'
                });
            },

            toUpdateMember(type, val) {
                this.$router.push('/updateMember/' + this.deptId + '/' + this.memberId + '/' + type + '/' + val)
            },

            async getMemberInfo() {
                let data = {
                    token: this.token,
                    deptId: this.deptId
                }
                let res = await this.$get("/spm/getMemberInfo", data)
                this.memberId = res.member.id
                this.headPortrait = res.member.headPortrait
                this.memberName = res.member.memberName
                this.srDate = res.member.srDate
                this.phone = res.member.phone
            },
            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .my-mbinfo {
        margin: 0 auto;
        height: 100%;
        position: relative;
        background-color: #EEEEEE;
        padding-top: 53px;
    }

    .mbinfo-titel {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 40px;
    }

    .van-cell__right-icon {
        margin: auto;
        margin-left: 0.10667rem;
        color: #969799;
    }

    ::v-deep .van-uploader__input {
        position: absolute;
        top: 0;
        left: 0;
        width: 280px;
        height: 100%;
        overflow: hidden;
        cursor: pointer;
        opacity: 0;
    }


</style>
